import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";

  type QuizDTO = object & ApiError

export const AddPackageToCart = (packageId:string): Promise<QuizDTO> => {
    return axios.post(`/cart/addPackageToCart/${packageId}`)
        .then(response => response.data as QuizDTO);
};
